module.exports = __webpack_public_path__ + "images/the-virgin-0fa7f0297185a68562ebcf8cbaa1826d.png";